'use client';

import { AppImage } from '@/components';
import { IMediaFileResponse } from '@/types/common';
import Image from 'next/image';
import { useState } from 'react';
import * as styles from './topImage.css';

interface ITopImageProps {
  additionalImage: IMediaFileResponse;
  alt: string;
  isClass?: boolean;
}

export const TopImage = ({ additionalImage, alt, isClass }: ITopImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  // 클래스 타입일 때는 Next.js Image를 직접 사용 (fill 모드)
  if (isClass) {
    return (
      <Image
        className={styles.image({ isLoaded, isClass })}
        src={additionalImage.url}
        alt={alt}
        fill
        draggable={false}
        style={{ objectFit: 'contain' }}
        onLoad={() => {
          setIsLoaded(true);
        }}
      />
    );
  }

  // 클래스가 아닐 때는 기존 AppImage 사용
  return (
    <AppImage
      className={styles.image({ isLoaded, isClass })}
      src={additionalImage.url}
      alt={alt}
      draggable={false}
      objectFit="contain"
      onLoad={() => {
        setIsLoaded(true);
      }}
      fill
      width={480}
      height={270}
    />
  );
};
